import React from 'react';
import * as S from './style';

import { Label, ProfileImage } from 'components';
import { ReactComponent as IcOwner } from 'assets/img/profile/ic_owner.svg';
import { ReactComponent as GrayArrow } from 'assets/img/common/ic_right_arrow_gray.svg';

export interface Props {
    profileImage: string;
    name: string;
    phone: string;
    isOwner: boolean;
    docStatus: string;
    activeStatus: string;
    onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
}

function UserItem({ profileImage, name, phone, isOwner, docStatus, activeStatus, onClick }: Props): React.ReactElement {
    const userStatus = (docStatus: string, activeStatus: string): React.ReactElement | string => {
        if (docStatus === 'approve_check') {
            return <Label fontStyle={'subtitle'} color={'gray_opacity_700'} contents={'승인 대기중'} />;
        } else if (docStatus === 'approve_reject') {
            return <Label fontStyle={'subtitle'} color={'red_900'} contents={'승인거절'} />;
        } else {
            if (activeStatus === 'active' && docStatus === 'approve') {
                return '';
            } else {
                return <Label fontStyle={'subtitle'} color={'gray_opacity_700'} contents={'-'} />;
            }
        }
    };

    return (
        <S.UserItem onClick={onClick}>
            <S.UserItemWrapper>
                <S.ProfileWrapper>
                    <ProfileImage size={'S'} background={profileImage} />
                </S.ProfileWrapper>
                <S.LabelWrapper>
                    <S.NameWrapper>
                        <Label fontStyle={'body2'} color={'gray_opacity_800'} contents={name} />
                        {isOwner ? <IcOwner /> : <Label fontStyle={'body2'} color={ 'blue_900' } contents={'직원'} />}
                    </S.NameWrapper>
                    <Label fontStyle={'subtitle'} color={'gray_opacity_600'} contents={phone} />
                </S.LabelWrapper>
            </S.UserItemWrapper>
            <S.StatusWrapper>
                {!isOwner ? userStatus(docStatus, activeStatus) : null}
                {onClick ? <GrayArrow /> : null}
            </S.StatusWrapper>
        </S.UserItem>
    );
}

export default UserItem;
